// extracted by mini-css-extract-plugin
export default {"home":"Hero_home__ZGdOk","png":"Hero_png__CjrON","details":"Hero_details__Q0nJq","gif":"Hero_gif__B96mR"};